/**
 * model-core 图片模型能力谓词
 *
 * 职责：把「模型有什么能力」从散落的裸 ID / 黑名单常量，收敛为「读 manifest 声明」。
 * 组件不再认识具体模型 id，只调用这些谓词。
 */
import { getImageModelConfig } from './registry';

/** 是否支持 @ 引用参考图（Banana / GPT Image 系列） */
export const supportsAtMention = (id?: string | null): boolean =>
  !!getImageModelConfig(id).supportAtMention;

/** 是否支持「参考图-角色特征」；默认支持，仅海螺01 等声明 false */
export const supportsReferenceRoleImage = (id?: string | null): boolean =>
  getImageModelConfig(id).supportsReferenceRoleImage !== false;

/** 是否支持参考图（图生图）；默认支持，仅即梦2.1 等声明 false */
export const supportsReferenceImage = (id?: string | null): boolean =>
  getImageModelConfig(id).supportsReferenceImage !== false;

/** 图生图（有参考图）时是否隐藏比例/尺寸参数（即梦3.0 等） */
export const hidesRatioWhenRefImage = (id?: string | null): boolean =>
  !!getImageModelConfig(id).refImageHidesRatio;

/** 是否声明参考模式（ref_type）选项；无 = 不支持单图参考（角色特征/人物长相） */
export const hasRefTypeOptions = (id?: string | null): boolean =>
  !!(getImageModelConfig(id).refTypeOptions?.length);

/** 是否有变化度滑杆（MJ） */
export const hasChangeDegreeToggle = (id?: string | null): boolean =>
  !!getImageModelConfig(id).toggles.changeDegree;

/** 是否有风格化滑杆（MJ） */
export const hasStylizeToggle = (id?: string | null): boolean =>
  !!getImageModelConfig(id).toggles.stylize;

/** 是否有原始模式单选（MJ） */
export const hasRawToggle = (id?: string | null): boolean =>
  !!getImageModelConfig(id).toggles.raw;

/** 是否有 MJ 系列专属控件（变化度/风格化/原始模式） */
export const hasMJControls = (id?: string | null): boolean =>
  !!getImageModelConfig(id).toggles.changeDegree;

/** 是否有背景参数（GPT Image 2.5 系列） */
export const hasBackgroundOption = (id?: string | null): boolean =>
  !!(getImageModelConfig(id).backgroundOptions?.length);
